"use strict";

const REQUIREMENT_TYPE = 'string';
const LANGUAGE = 'en';
const PRIORITY = 1;
const FIRSTNAME_FIELD = 'firstname';
const FIRSTNAME_MESSAGE = 'Check you\'ve spelled your name correctly';
const LASTNAME_FIELD = 'lastname';
const LASTNAME_MESSAGE = 'Check you\'ve spelled your last name correctly';

let doesStringContainNumbers = (name) => !!name.match('.*\\d+.*');
let doesStringContainBackslash = (name) => !!name.match(/\\/g);
let validateStringPredicate = (name) => !(doesStringContainNumbers(name) || doesStringContainBackslash(name));

let createParsleyNameValidator = (field, message) => {
    window
        .Parsley
        .addValidator(field, {
            requirementType: REQUIREMENT_TYPE,
            priority: PRIORITY,
            validateString: value => validateStringPredicate(value)
        })
        .addMessage(LANGUAGE, field, message)
};

class PersonNameValidator {
    constructor() {
        createParsleyNameValidator(FIRSTNAME_FIELD, FIRSTNAME_MESSAGE);
        createParsleyNameValidator(LASTNAME_FIELD, LASTNAME_MESSAGE);
    }
}

module.exports = new PersonNameValidator();